<div class="bg-gray-50 rounded-2xl p-6 border border-gray-300">
  @if (isLoading) {
    <div class="text-center py-8">
      <p class="text-gray-600">Cargando tipos de tickets...</p>
    </div>
  } @else if (error) {
    <div class="text-center py-8">
      <p class="text-red-600">Error al cargar los tipos de tickets</p>
    </div>
  } @else if (tiposTicket.length === 0 && !isLoading) {
    <div class="text-center py-8">
      <p class="text-gray-600">No hay tickets disponibles para este evento</p>
    </div>
  } @else {
    <!-- Header -->
    <div class="mb-6">
      <div class="flex items-center mb-2">
        <span class="bg-white rounded-full w-8 h-8 flex items-center justify-center border-2 border-gray-800 text-sm font-bold mr-3">1</span>
        <h2 class="text-lg font-semibold text-gray-800">Selecciona tus entradas</h2>
      </div>
    </div>

    <!-- Tabla de tickets -->
    <div class="bg-white rounded-xl overflow-hidden border border-gray-200">
      <!-- Header de tabla -->
      <div class="grid grid-cols-12 gap-4 px-6 py-3 bg-gray-100 border-b border-gray-200 text-sm font-medium text-gray-700">
        <div class="col-span-6">Tipo</div>
        <div class="col-span-3 text-right">Precio</div>
        <div class="col-span-3 text-right">Cantidad</div>
      </div>

      <!-- Tipos de ticket -->
      @for (tipoTicket of tiposTicket; track tipoTicket.tipoticketid) {
        <div class="border-b border-gray-200 last:border-b-0">
          <!-- Nombre de la localidad -->
          <div class="px-6 py-4 bg-gray-50">
            <h3 class="font-bold text-gray-900">{{ tipoTicket.nombre_localidad }}</h3>
            @if (tipoTicket.aforo_disponible === 0) {
              <p class="text-sm text-red-600 mt-1">Agotado</p>
            } @else if (tipoTicket.aforo_disponible < 10) {
              <p class="text-sm text-orange-600 mt-1">Solo quedan {{ tipoTicket.aforo_disponible }} disponibles</p>
            }
          </div>

          <!-- Precios de este tipo de ticket -->
          @if (tipoTicket.precios && tipoTicket.precios.length > 0) {
            @for (precio of tipoTicket.precios; track getPrecioId(precio)) {
            <div class="grid grid-cols-12 gap-4 px-6 py-4 items-center hover:bg-gray-50 transition-colors">
              <!-- Nombre del precio -->
              <div class="col-span-6">
                <div class="flex items-center">
                  <span class="inline-block w-3 h-3 bg-[#e8343f] rounded-sm mr-2"></span>
                  <div>
                    <p class="font-medium text-gray-900">{{ precio.nombre_precio }}</p>
                    @if (precio.nombre_precio.includes('Preventa')) {
                      <p class="text-xs text-gray-500">(Preventa)</p>
                    }
                  </div>
                </div>
              </div>

              <!-- Precio -->
              <div class="col-span-3 text-right">
                <div class="space-y-1">
                  <p class="font-bold text-gray-900">${{ precio.precio_total.toFixed(2) }} {{ precio.nombre_moneda }}</p>
                  @if (precio.precio_cargo_servicio > 0) {
                    <!-- <p class="text-xs text-gray-500">Cargo servicio: ${{ precio.precio_cargo_servicio_final.toFixed(2) }}</p> -->
                  }
                  @if (precio.precio_servicio_administrativo > 0) {
                    <!-- <p class="text-xs text-gray-500">Serv. administrativo: ${{ precio.precio_servicio_administrativo_final.toFixed(2) }}</p> -->
                  }
                </div>
              </div>

              <!-- Selector de cantidad -->
              <div class="col-span-3 text-right">
                @if (tipoTicket.aforo_disponible === 0) {
                  <span class="text-sm text-gray-400">No disponible</span>
                } @else {
                  <select 
                    [value]="getSelectedQuantity(tipoTicket.tipoticketid, getPrecioId(precio))"
                    (change)="setSelectedQuantity(tipoTicket.tipoticketid, getPrecioId(precio), +$any($event.target).value)"
                    class="w-20 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#e8343f] focus:border-transparent outline-none"
                  >
                    @for (option of getQuantityOptions(tipoTicket.aforo_disponible - tipoTicket.tickets_reservados); track option) {
                      <option [value]="option">{{ option }}</option>
                    }
                  </select>
                }
              </div>
            </div>
          }
          } @else {
            <div class="px-6 py-4 text-sm text-orange-600">
              No hay precios disponibles para este tipo de ticket en la venta web.
            </div>
          }
        </div>
      }
    </div>

    <!-- Footer con nota informativa -->
    <div class="mt-4 text-sm text-gray-600 bg-blue-50 border border-blue-200 rounded-lg p-4">
      <p class="font-medium text-blue-900 mb-1">Valores Incluyen Cargos</p>
      <p class="text-blue-800">Los precios mostrados ya incluyen el cargo por servicio, servicio administrativo (si aplica) y todos los impuestos aplicables.</p>
    </div>

    <!-- Botón agregar al carrito -->
    @if (hasSelectedTickets()) {
      <div class="mt-6 bg-white rounded-xl p-4 border border-gray-200">
        <div class="flex justify-between items-center mb-4">
          <div>
            <p class="text-sm text-gray-600">Total de entradas: <span class="font-bold">{{ getTotalSelected() }}</span></p>
            <p class="text-2xl font-bold text-gray-900">${{ getTotalPrice().toFixed(2) }} USD</p>
          </div>
        </div>
        <button 
          (click)="addToCart()"
          [disabled]="isAddingToCart"
          [class.opacity-50]="isAddingToCart"
          [class.cursor-not-allowed]="isAddingToCart"
          class="w-full bg-[#e8343f] text-white py-4 rounded-lg text-lg font-semibold hover:bg-red-700 transition-colors disabled:hover:bg-[#e8343f]"
        >
          @if (isAddingToCart) {
            <span class="flex items-center justify-center">
              <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Agregando...
            </span>
          } @else {
            Agregar Al Carrito
          }
        </button>
      </div>
    }
  }
</div>
